import { render } from "./politique_confidentialite.vue?vue&type=template&id=914946e0"
import script from "./politique_confidentialite.vue?vue&type=script&lang=js"
export * from "./politique_confidentialite.vue?vue&type=script&lang=js"

import "./politique_confidentialite.vue?vue&type=style&index=0&id=914946e0&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__